import React from 'react'
import PropTypes from 'prop-types'
import {
  TitlePrimary,
  TitleSecondary,
  SpacerVertical,
  ParagraphSecondary
} from 'mage-deps/@klarna/bubble-ui'
import RelatedContent from './RelatedContent'
import { Message } from 'mage-i18n'
import FeedbackSelector from './FeedbackSelector'
import FreeTextFeedback from './FreeTextFeedback'
import ContactButton from './ContactButton'

MoreHelpPage.propTypes = {
  parameters: PropTypes.object.isRequired
}

function MoreHelpPage({ parameters }) {
  const { articleId, articleTitle } = parameters

  return (
    <div>
      <TitlePrimary id="uhqm-more-help-title">
        <Message path="hqm.feedback.title" fallback="Was this helpful?" />
      </TitlePrimary>
      <SpacerVertical small />
      <FeedbackSelector value="no" />
      <SpacerVertical medium />
      <FreeTextFeedback articleId={articleId} />
      <SpacerVertical large />
      <ParagraphSecondary>
        <Message
          path="hqm.moreHelp.relatedArticlesParagraph"
          fallback="We're sorry that this didn't help. Maybe some of these articles might help you?"
        />
      </ParagraphSecondary>
      <SpacerVertical large />
      <RelatedContent
        articleId={articleId}
        analyticsCategory="uhqm/article-title/related/more-help"
      />
      <SpacerVertical large />
      <TitleSecondary>
        <Message path="hqm.moreHelp.stillQuestionsTitle" fallback="Still have Questions?" />
      </TitleSecondary>
      <SpacerVertical extraSmall />
      <ParagraphSecondary>
        <Message
          path="hqm.moreHelp.stillQuestionsParagraph"
          fallback="You can also contact us directly."
        />
      </ParagraphSecondary>
      <SpacerVertical medium />
      <ContactButton
        articleId={articleId}
        articleTitle={articleTitle}
        analyticsCategory="uhqm/contact-button/more-help"
      />
    </div>
  )
}

export default MoreHelpPage
